import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import {BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CategoryPage from './pages/CategoryPage';
import Category from './pages/Category';
import About from './pages/Aboutus';
import Contact from './pages/Contact';
import Gallery from './pages/Galery';
import Notfound from './components/Notfound';
import Searchresult from './pages/Searchresult';
import { FloatingWhatsApp } from 'react-floating-whatsapp';


function App() {
  return (
    <div className="App">
      <Header />
      <FloatingWhatsApp phoneNumber='77010689960' accountName='Kromsan' avatar='/images/logo.png' statusMessage='Был(а) 1 минуту назад' chatMessage='Вас приветствует компания Kromsan! Напишите нам, оператор вам обязательно ответит'/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/category/:groupId/' element={<Category/>}/>
        <Route path='/categori/:categoryId/' element={<CategoryPage/>} />
        <Route path='/about' element={<About/>}/>
        <Route path='/galery' element={<Gallery/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/search-result' element={<Searchresult/>}/>
        <Route path='*' element={<Notfound/>}/>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
